// extracted by mini-css-extract-plugin
export default {"nav":"NavLinks_nav__mwFM-","links":"NavLinks_links__58ADF","navLink":"NavLinks_navLink__lZF8Z","active":"NavLinks_active__IBKwf"};